import { SlotGameType1_21 } from "../SlotGameType1_21";

// {
	export class GoldAndRumBAFillingPot21 extends SlotGameType1_21
	{
	}
// }